<!-- 质量管理 圆环图 -->
<template>
  <div>
    <div class="circle-wrapper">
      <div class="circle-content" :id="id"></div>
      <div class="title">{{title}}</div>
      <div class="content">
        <div class="sp1" :style="percent=='无数据'?'fontSize:14px;color:#e1e1eb':''">{{percent?percent:'无数据'}}{{percent?unit:''}}</div>
        <!-- <div class="sp2">{{unit}}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["color", "percent", "id", "title", "content", "unit", "name1", "name2"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    const myChart = echarts.init(document.getElementById(this.id));
    //console.log(this.content)
    //console.log(this.percent)
    let that = this
    const option = {
      tooltip: {
          trigger: 'item',
          position:'bottom',
          // formatter: '{a} <br/>{b}: {c}' + this.unit
          formatter: function(){
            var res=option.series[0].name+'<br />';
            var myseries=option.series;
            for(var i=0;i<myseries.length;i++){
                //在内部继续循环series[i],从data中判断：当地区名称等于params.name的时候就将当前数据和名称添加到res中供显示
                for(var k=0;k<myseries[i].data.length;k++){
                    let setV = myseries[i].data[k].value?myseries[i].data[k].value:'无数据'
                    let setU = myseries[i].data[k].value?that.unit:''
                    ////console.log(myseries[i].data[k].name);
                    //如果data数据中的name和地区名称一样
                    // if(myseries[i].data[k].name==params.name){
                        //将series数据系列每一项中的name和数据系列中当前地区的数据添加到res中
                        res+=myseries[i].data[k].name+':'+ setV +setU+'<br />';
                    // }
                }
            }
            //console.log(res)
            return res
          }
      },
      series: [
        {
          name: this.title,
          type: "pie",
          radius: ["80%", "100%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '14',
              fontWeight: 'bold'
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: this.percent,
              name: this.name1,
              itemStyle: { color: this.color  },
            },
            {
              value: this.content,
              name: this.name2,
              itemStyle: { color: "#e1e1eb"},
            },
          ],
          animation: false
        },
      ],
    };
    myChart.setOption(option);
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped="">
.circle-wrapper {
  position: relative;
  // margin-left: 38px;
  // margin-right: 20px;
}
.circle-content {
  width: 80px;
  height: 80px;
}
.title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8C8C8C;
  font-size: 12px;
  line-height: 2;
  text-align: center;
  margin: 8px auto 10px;
  width: 100px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.content {
  position: absolute;
  width: 100%;
  top: 32px;
  // left: 28px;
  text-align: center;
  .sp1 {
    font-size: 16px;
    font-weight: normal;
  }
  .sp2 {
    margin-left: 2px;
    font-size: 12px;
  }
}
</style>